import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const CardWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    border: 1px solid ${({ theme }) => theme.colors.semantic.tableBorder};
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.semantic.drawerBackground};
`

export const CardHeader = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.tableBorder};
`

export const CardBody = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px;
`

export const MetaRow = styled('div')`
    display: flex;
    align-items: baseline;
    gap: 6px;

    .key {
        flex-shrink: 0;
        overflow: initial !important;
    }
`

export const OverflowChip = styled('span')<{ theme?: TTheme }>`
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 10px;
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    color: ${({ theme }) => theme.colors.primary[400]};
`

export const ReasonRow = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;

    .reason-title {
        display: flex;
        align-items: center;
        gap: 6px;
    }
`
